/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectTextIcon20Light = forwardRef('CommentRectTextIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 10.52a.5.5 0 0 1 .5-.5h5a.5.5 0 1 1 0 1h-5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M5.5 7a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1h-8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-3.342l-4.085 2.859A1 1 0 0 1 5 17.039V15a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h.5a.5.5 0 0 1 .5.5v2.54l4.213-2.95A.5.5 0 0 1 10.5 14H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5Z" })));
});
